import React from "react";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import "./VeevaCardDetails.scss";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
// import parse from "html-react-parser";

function AssetAccordion(props) {
  let counter = 0;
  let itemsCout =
    props.assets.length -
    props.assets.filter((x) => x?.imageUrl == "null" || x?.imageUrl === null)
      .length;
  return (
    <div className="claimDetails " style={{ paddingRight: "18px" }}>
      <div className="accordion leftcard">
        <Accordion
          expanded={props.expanded === `panel-${3}`}
          className="accordionLeftpane"
          onChange={props.handleChange(`panel-${3}`)}
        >
          <AccordionSummary
            expandIcon={
              props.expanded === `panel-${3}` ? (
                <RemoveIcon fontSize="small" className="accordionIcons" />
              ) : (
                // <p>-</p>
                <AddIcon fontSize="small" className="accordionIcons" />
                // <p>+</p>
              )
            }
            aria-controls={`panelprops.Claims-${3}a-content`}
            id={`panelprops.Claims-${3}a-header`}
            className="accordion-summary"
          >
            <div className="claimName nextmod" style={{ displex: "flex" }}>
              {"Assets"}
              {/* <div className="countItems countItems1">{`(${itemsCout} items)`}</div> */}
            </div>
            <span class="claimNameCount">{`(${itemsCout} items)`}</span>
          </AccordionSummary>
          <AccordionDetails className={"accordDetails  accordVisual "}>
            {props.assets.length > 0 &&
              props.assets?.map(
                (eachElement, index) =>
                  eachElement?.imageUrl &&
                  eachElement?.imageUrl !== "null" && (
                    <div>
                      <div className="accDetails2 ">
                        <div className="typeHeading">Assets</div>

                        {eachElement?.mustUse && (
                          <div className="colorCode">
                            <div
                              className={
                                "relationDependancy relationColorMandatory"
                              }
                            ></div>
                            <span className="clrCodeText">Must have</span>
                          </div>
                        )}
                        {/* <div id={supText.componentType+index} className="typeText" data-assetId={assetId}  onDoubleClick={ */}
                        <img
                          alt="Asset Image"
                          className="img-fluid"
                          src={eachElement.imageUrl}
                          draggable={true}
                          onDragStart={(e) =>
                            props.sendAtomDetails2Canvas({
                              id: e.target.parentNode.id || e.target.id,
                              type: "Image",
                              data: eachElement.imageUrl,
                            })
                          }
                        ></img>
                      </div>
                    </div>
                  )
              )}
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}

export default AssetAccordion;
